import React from "react";
import { leftArrow, rightArrow } from "../Constant/images";

const LightBox = ({
  img,
  totalImgNum,
  currentIndex,
  handleRight,
  handelLeft,
}) => {
  const lightImg = img;

  return (
    <div className="box_body">
      <div className="box_content">
        <div className="left_arrow arrow">
          <img src={leftArrow} alt="" onClick={handelLeft} />
        </div>
        <div className="img_content">
          <div className="img_div">
            <img src={lightImg} alt="imgs" />
            <p className="length" style={{ color: "white" }}>
              {currentIndex + 1} of {totalImgNum}
            </p>
          </div>
        </div>

        <div className="right_arrow arrow">
          <img src={rightArrow} alt="" onClick={handleRight} />
        </div>
      </div>
      <div className="responsive_arrow">
        <div className="left_arrow res_arrow">
          <img src={leftArrow} alt="" onClick={handelLeft} />
        </div>
        <div className="right_arrow res_arrow">
          <img src={rightArrow} alt="" onClick={handleRight} />
        </div>
      </div>
    </div>
  );
};

export default LightBox;
